export interface PageMeta {
  title: string;
  description: string;
}

/** Metadata for static routes. Used by page components and by the server so the initial HTML matches the rendered page. */
export const STATIC_PAGE_META: Record<string, PageMeta> = {
  '/': {
    title: 'Fast Repair | Book Independent Local Repair Engineers',
    description: 'Fast Repair is an online booking platform that matches you with independent, vetted local engineers for appliance repairs, plumbing and heating. Free to use.',
  },
  '/quote': {
    title: 'Get a Repair Quote | Fast Repair',
    description: 'Get matched with an independent local repair engineer through Fast Repair. Enter your postcode to see availability and pricing. Free to use.',
  },
  '/about': {
    title: 'About Fast Repair | Online Repair Booking Platform',
    description: 'Fast Repair is an online platform operated by ClickAhead Marketing Ltd that matches customers with independent local repair businesses.',
  },
  '/contact-us': {
    title: 'Contact Us | Fast Repair',
    description: 'Get in touch with Fast Repair or find the right contact for your needs.',
  },
  '/due-diligence-checks': {
    title: 'Partner Checks | Fast Repair',
    description: 'The checks Fast Repair carries out on independent partner repair businesses: public liability insurance, identity and business status, and Gas Safe registration for gas work.',
  },
  '/customers': {
    title: 'Fast Repair | Features for Customers',
    description: 'Discover the transparency, speed, and convenience of the Fast Repair Customer Portal. Book independent local engineers and track your booking.',
  },
  '/partners': {
    title: 'Fast Repair | Partner Platform for Independent Engineers',
    description: 'The ultimate platform for independent engineers and repair businesses to get consistent jobs, reduce admin, and maximize earnings.',
  },
  '/privacy-policy': {
    title: 'Privacy Policy | Fast Repair',
    description: 'Read the Fast Repair Privacy Policy to understand how we collect, use, and handle your personal information.',
  },
  '/privacy-policy-4': {
    title: 'Privacy Policy | Fast Repair',
    description: 'Read the Fast Repair Privacy Policy to understand how we collect, use, and handle your personal information.',
  },
  '/terms-conditions': {
    title: 'Terms & Conditions | Fast Repair',
    description: 'View the full Terms and Conditions for booking an appliance repair via the Fast Repair platform.',
  },
};

export function buildServiceMeta(serviceName: string, locationName?: string | null): PageMeta {
  const locationSuffix = locationName && locationName !== 'Your Area' ? ` in ${locationName}` : '';
  return {
    title: `${serviceName} Repairs${locationSuffix} | Book a Local Engineer | Fast Repair`,
    description: `Fast Repair matches you with an independent, vetted local ${serviceName.toLowerCase()} repair engineer${locationSuffix}. Same & next day appointments. Free to use – get a quote today.`,
  };
}
